export default __webpack_public_path__ + "static/design-pro-6140809a0a21adba9651df002411e2a2.png";